/*eslint-disable */
import root from '../_helpers/roots';
let todoListApiUrl = root.todoListApiUrl.link;
let allToDoRemoveApiUrl = root.allToDoRemoveApiUrl.link;
let toDoFiltersApiUrl = root.toDoFiltersApiUrl.link;
let shareTodoApiUrl = root.shareTodoApiUrl.link;
import axios from 'axios';
import Vue from 'vue'
export default {
  state: {
    getToDoListState:{},
  },
  mutations: {
    getToDoListMutation(state, value) {
      Vue.set(state, 'getToDoListState', value);
    },
  },
  actions: {
    getSharedToDoListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(shareTodoApiUrl)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    shareToDoWithUserAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(shareTodoApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getFiltersToDoListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(toDoFiltersApiUrl + '?is_completed=' + payload.status)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    allToDoRemoveAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(allToDoRemoveApiUrl)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    toDoRemoveByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(todoListApiUrl + '?id=' + payload.id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    postToDoListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(todoListApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getToDoListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(todoListApiUrl)
          .then((response) => {
            context.commit('getToDoListMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateToDoInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(todoListApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    getToDoListGetters : state => state.getToDoListState
  }
}